/**
 * @Date: 2020-05-25 14:42
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import Main from '@/components/Layout/Layout'
import SubMain from '@/views/Main'

export default {
  sort: 2,
  routers: [
    {
      path: '/Settings',
      name: 'settings',
      component: Main,
      meta: {
        isHideInMenu: false,
        isCache: false,
        icon: 'setting',
        title: '基础配置'
      },
      redirect: '/Settings/CurrencyManage/Currency',
      children: [
        {
          path: '/Settings/CurrencyManage',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '币种管理'
          },
          redirect: '/Settings/CurrencyManage/Currency',
          children: [
            {
              path: '/Settings/CurrencyManage/Currency',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '货币币种'
              },
              component: () => import('@/views/Settings/CurrencyManage/Currency.vue')
            }
          ]
        },
        {
          path: '/Settings/Product',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '产品管理'
          },
          redirect: '/Settings/Product/Product',
          children: [
            {
              path: '/Settings/Product/Product',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '产品管理'
              },
              component: () => import('@/views/Settings/Product/Product.vue')
            }
          ]
        }
        // {
        //   path: '/Settings/BusinessHours',
        //   name: '',
        //   component: SubMain,
        //   meta: {
        //     isHideInMenu: false,
        //     isCache: false,
        //     icon: 'solution',
        //     title: '营业时间'
        //   },
        //   redirect: '/Settings/BusinessHours/BusinessHours',
        //   children: [
        //     {
        //       path: '/Settings/BusinessHours/BusinessHours',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '营业时间'
        //       },
        //       component: () => import('@/views/Settings/BusinessHours/BusinessHours.vue')
        //     }
        //   ]
        // },
        // {
        //   path: '/Settings/NoticeManage',
        //   name: '',
        //   component: SubMain,
        //   meta: {
        //     isHideInMenu: false,
        //     isCache: false,
        //     icon: 'solution',
        //     title: '通知管理'
        //   },
        //   redirect: '/Settings/NoticeManage/NoticeObj',
        //   children: [
        //     {
        //       path: '/Settings/NoticeManage/NoticeMapping',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '通知映射'
        //       },
        //       component: () => import('@/views/Settings/BusinessHours/BusinessHours.vue')
        //     },
        //     {
        //       path: '/Settings/NoticeManage/NoticeObj',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '通知对象'
        //       },
        //       component: () => import('@/views/Settings/NoticeManage/NoticeObj.vue')
        //     },
        //     {
        //       path: '/Settings/NoticeManage/NoticeTemplate',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '通知模板'
        //       },
        //       component: () => import('@/views/Settings/NoticeTemplate/NoticeTemplate.vue')
        //     },
        //     {
        //       path: '/Settings/NoticeManage/NoticeChannel',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '通知渠道'
        //       },
        //       component: () => import('@/views/Settings/NoticeChannel/NoticeChannel.vue')
        //     }
        //   ]
        // }
      ]
    }
  ]
}
